import axiosHttp from './axios-http'
import customAjax from './customAjax.js'



// export default instance
export default {
  install: function (vm) {
    vm.prototype.$axiosHttp = axiosHttp
    vm.prototype.$customAjax = customAjax
  }
}



// WEBPACK FOOTER //
// ./src/utils/http.js